<script setup lang="ts">
  import { useJourneyTemplateStore } from '@/store/journey-template.store'
  import { storeToRefs } from 'pinia'
  import { useLegacyAppStore } from '@/store/legacy-app.store'
  import FormHeading from '@/components/form/FormHeading.vue'
  import ExtraDropDown from '@/components/idf-modal/ExtraDropDown.vue'
  import ExtraFormInput from '@/components/idf-modal/ExtraFormInput.vue'
  import type {
    IdfJourneyTemplate,
    JourneyTemplateWithExtraOptions,
    JourneyValidationErrors,
  } from '@/types/idf-journey-product'
  import type { Nullish } from '@logistiek-zonder-papier/lzp-library'
  import { computed, onMounted } from 'vue'

  const journeyTemplateStore = useJourneyTemplateStore()
  const { journeyTemplate } = storeToRefs(journeyTemplateStore)

  const appStore = useLegacyAppStore()
  const { journeyTemplateFieldConfigs } = storeToRefs(appStore)

  const props = defineProps<{
    error?: JourneyValidationErrors | Nullish
  }>()

  function hasExtraOptions(type: IdfJourneyTemplate): type is JourneyTemplateWithExtraOptions {
    return type.extraOptions != null
  }

  const templateWithOptions = computed<JourneyTemplateWithExtraOptions | null>(() => {
    if (!hasExtraOptions(journeyTemplate.value)) return null
    return journeyTemplate.value
  })

  function getComponentForType(typeName: string) {
    if (typeName === 'select') return ExtraDropDown
    return ExtraFormInput
  }

  onMounted(() => {
    if (!journeyTemplate.value.extraOptions) {
      journeyTemplate.value.extraOptions = {}
    }
  })
</script>

<template>
  <div v-if="journeyTemplateFieldConfigs.length > 0 && templateWithOptions">
    <FormHeading label="Extra opties" />

    <div v-for="config in journeyTemplateFieldConfigs" :key="config.key">
      <component
        :is="getComponentForType(config.type)"
        v-model="templateWithOptions"
        :field-config="config"
        :error="props.error?.extraOptions?.[config.key]"
      />
    </div>
  </div>
</template>

<style scoped></style>
